module.exports = __webpack_public_path__ + "img/step37_2_mfp_slide_refeed_preventers - Copy.4187800c.png";